export default __webpack_public_path__ + "static/media/blog-img84.6fd8f46a.jpg";